






































import { Component, Prop, Vue } from "vue-property-decorator";
import { INote } from "@/models/notes";

@Component
export default class Note extends Vue {
  // Props

  @Prop({ required: true })
  public note!: INote["note"];

  @Prop({ required: true })
  public author!: string;

  @Prop({ required: true })
  public datetime!: string;

  @Prop({ default: false })
  public isPinned!: boolean;

  @Prop({ default: undefined })
  public onEdit!: Function;

  @Prop({ default: undefined })
  public onPin!: Function;

  @Prop({ default: undefined })
  public onDelete!: Function;
}
